export { default } from "./ArticleContent";
